import React from 'react';
import { Field } from 'formik';
import { injectIntl, FormattedMessage } from 'react-intl';
import { FormButtonGroup, FormRadioButton } from '~form';
import { H5 } from '~typography';
import StyleOptionsContainer from './StyleOptionsContainer';
import StyleOptionsButtonInner from './StyleOptionsButtonInner';
import commercePropTypes from '../../../prop-types/commercePropTypes';

var StyleOptions = function StyleOptions(_ref) {
  var options = _ref.options,
      index = _ref.index,
      onOptionChange = _ref.onOptionChange,
      disabled = _ref.disabled,
      showLabel = _ref.showLabel,
      intl = _ref.intl;

  var handleProductChange = function handleProductChange(value) {
    onOptionChange(value);
  };

  return options && /*#__PURE__*/React.createElement(StyleOptionsContainer, null, showLabel && /*#__PURE__*/React.createElement(H5, {
    as: "span",
    isUppercase: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.size.label"
  })), /*#__PURE__*/React.createElement(Field, {
    component: FormButtonGroup,
    id: "variantId" + index,
    name: "variantId",
    title: intl.formatMessage({
      id: 'commerce.availableStyleOptions.label'
    }),
    role: "radiogroup",
    buttonSize: "sm",
    buttonSkin: "muted",
    buttonType: "pills"
  }, options.map(function (item, itemIndex) {
    var value = item.value,
        label = item.label;
    return /*#__PURE__*/React.createElement(Field, {
      key: itemIndex,
      component: FormRadioButton,
      id: "variantId" + index + itemIndex,
      name: "variantId",
      value: value,
      onChange: function onChange(_ref2) {
        var target = _ref2.target;
        return handleProductChange(target.value);
      },
      disabled: disabled
    }, /*#__PURE__*/React.createElement(StyleOptionsButtonInner, null, label));
  })));
};

StyleOptions.defaultProps = {
  options: null,
  onOptionChange: null,
  disabled: false,
  showLabel: true
};
export default injectIntl(StyleOptions);